export { default } from "./getAssignmentActivities";
